import React from "react";
import "./index.m.css";

export const QuoteIcon = () => (
  <svg styleName="quoteIcon" width="36" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fillRule="evenodd" clipRule="evenodd" d="M29.5485 8C34.1852 8 37.9367 11.6 37.9367 16C37.9367 20.4 34.143 24 29.5063 24C24.8696 24 21.0759 20.4 21.0759 16C21.0759 7.16 28.6211 0 37.9367 0C37.9367 0 32.4148 1.96 29.5485 8ZM16.8608 16C16.8608 20.4 13.0671 24 8.43038 24C3.79367 24 -3.8147e-06 20.4 -3.8147e-06 16C-3.8147e-06 7.16 7.54519 0 16.8608 0C16.8608 0 11.3389 1.96 8.47253 8C13.1092 8 16.8608 11.6 16.8608 16Z" fill="var(--gold)"/>
  </svg>
);
